import * as React from 'react';
import type { ControlProps } from '@web-config-app/entity-form';
import { useDataSource } from '@web-config-app/entity-form';
import { UrlDataSourceEnumControl } from './url-data-source-enum-control/url-data-source-enum-control.component';
import { EntityDataSourceEnumControl } from './entity-data-source-enum-control/entity-data-source-enum-control.component';

export const DataSourceEnumControl: React.FC<ControlProps> = (props) => {
  const { schema } = props;
  const { 'x-entity-data-source': dataSourceConsumer } = schema;

  if (!dataSourceConsumer?.dataSource) {
    throw new Error(
      `DataSourceEnumControl: Data source was not provided for 'x-entity-data-source' consumer`,
    );
  }

  const dataSource = useDataSource(dataSourceConsumer?.dataSource);

  if (dataSource !== undefined) {
    if (dataSource.value === undefined) {
      throw new Error(
        `Could not find a data source for '${dataSourceConsumer?.dataSource}'`,
      );
    }

    const { type } = dataSource;

    switch (type) {
      case 'url':
        return (
          <UrlDataSourceEnumControl
            {...props}
            dataSource={dataSource}
            dataSourceConsumer={dataSourceConsumer}
          />
        );
      case 'entity':
        return (
          <EntityDataSourceEnumControl
            {...props}
            dataSource={dataSource}
            dataSourceConsumer={dataSourceConsumer}
          />
        );
      default:
        return null;
    }
  }

  return null;
};
